<script lang="ts">
    import SignupFormSms from './signup-form-sms.svelte'

    function loginSuccess() {
        location.href = '/'
    }
</script>

<main class="root">
    <div class="in">
        <div class="box pub">
            <div class="-ilustration mb-3 text-center">
                <img src="/img/sign-2.png" alt="" />
            </div>
            <span class="e-1 mt-2 mb-2"><b>Agenda é o básico</b>, o Zandu...</span>
            <div class="mt-3">
                <ul>
                    <li>É uma <b>secretária virtual</b></li>
                    <li>É uma <b>ferramenta de comunicação</b></li>
                    <li>É uma ferramenta de <b>automação de marketing</b></li>
                    <li>É uma ferramenta de <b>reputação social</b></li>
                    <li>É uma ferramenta de <b>produtividade</b></li>
                    <li>É um <b>CRM</b> para prestadores de serviço</li>
                </ul>
            </div>
        </div>
        <div class="box form">
            <div>
                <div class="-logo mb-3 text-center">
                    <img class="mb-3" src="/img/logo_white.png" alt="" />
                </div>
                <SignupFormSms on:success={loginSuccess} />
            </div>
        </div>
    </div>
</main>

<style>
    .e-1 {
        font-weight: 300;
        font-size: 24px;
        display: inline-block;
    }
    .e-1 b {
        font-weight: 300;
        background: orange;
    }
    b {
        background: yellowgreen;
        font-weight: 400;
        padding-left: 4px;
        padding-right: 4px;
        border-radius: 4px;
    }

    .root {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
        width: 100vw;
        background: url('/img/bg_login.png') #333333 center center no-repeat;
        background-size: auto;
    }
    .root .-ilustration img {
        max-height: 220px;
    }
    .root .in {
        /* From https://css.glass */
        background: rgba(0, 0, 0, 0.4);
        border-radius: 16px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
        backdrop-filter: blur(15px);
        -webkit-backdrop-filter: blur(15px);
        border: 1px solid rgba(0, 0, 0, 0.06);
        flex: 0 1 960px;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        margin: 8px;
    }
    .in .box {
        flex: 1 1 100px;
        min-height: 510px;
    }

    .in .pub {
        background-color: white;
        padding: 16px 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    .in .form {
        padding: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .in .form > div {
        flex-grow: 1;
    }

    @media (max-width: 900px) {
        .in .pub {
            display: none;
        }
    }
</style>
